export const NARRATIVAS_USINAGEM = [
  'CANAL PARADO',
  'CANAL VAZADO',
  'CANAL DECORATIVO CONFORME DOCUMENTO TÉCNICO',
  'USINAR REBAIXO',
  'USINAR 45º',
  'FAZER USINAGEM CONFORME GABARITO DE FIXAÇÃO DE PARAFUSO',
];

export const OPCAO_NARRATIVA_MANUAL = '__MANUAL__';

const CODIGOS_RECORTE = new Set(['027', '039']);
const CODIGOS_USINAGEM = new Set(['004']);

export function codigoBaseOperacao(codigo = '') {
  return String(codigo).split('.')[0];
}

export function operacaoEhRecorte(codigo) {
  return CODIGOS_RECORTE.has(codigoBaseOperacao(codigo));
}

export function operacaoEhUsinagem(codigo) {
  return CODIGOS_USINAGEM.has(codigoBaseOperacao(codigo));
}

export function normalizarNarrativa(valor = '') {
  return String(valor)
    .replace(/[;\r\n\t]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleUpperCase('pt-BR');
}

export function narrativaUsinagemEhPredefinida(valor = '') {
  return NARRATIVAS_USINAGEM.includes(valor);
}

export function alertaNarrativa(op) {
  if (op?.narrativa?.trim()) return '';
  if (operacaoEhRecorte(op?.operacao)) return 'Defina uma narrativa para a operação de recorte.';
  if (operacaoEhUsinagem(op?.operacao)) return 'Informe uma narrativa';
  return '';
}
